export const selectDrives = state => state.dfd.drives
export const selectMapDrives = state => state.dfd.mapDrives
export const selectLists = state => state.dfd.lists
export const selectLeads = state => state.dfd.leads
export const selectDrivesStats = state => state.dfd.drivesStats
export const selectListsStats = state => state.dfd.listsStats
